import { keyframes } from 'styled-components'

export const loaderDotScaleAnim = keyframes`
    0% {
      transform: scale(1);
      animation-timing-function: cubic-bezier(0.33, 0, 0, 1);
    }
    50% {
      transform: scale(0.1);
      animation-timing-function: cubic-bezier(0.33, 0, 0, 1);
    }
    100% {
      transform: scale(1);
    }
  }
  `
export const pageFadeInAnim = keyframes`
  0%{
     transform: translateY(75px);
     opacity:0
  }
  10%{
    transition-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
    transform: translateY(75px);
    opacity:0
  }
  50%{
    transition-timing-function: cubic-bezier(0.29, 0.2, 0.62, 1);
    transform:translateY(-10px);
    opacity:0.5;
  }
  100%{
    transform:translateY(0px)
    opacity:1
   } 
`
export const pageFadeOutAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
     transform: translateY(0);
     opacity:1;
    }
    100%{
      transform:translateY(123px);
      opacity:0;
   } 
`

export const popUpSlideUpAnim = keyframes`
  0% {
    animation-timing-function: cubic-bezier(0.29, 0.14, 0.62, 1);
    transform: translateX(50%) translateY(0px);
    opacity: 1;
  }
  50% {
    animation-timing-function: cubic-bezier(0.42, 0, 0.07, 0.93);
    transform: translateX(50%) translateY(20px);
  }
  100% {
    transform: translateX(50%) translateY(-120px);
    opacity: 0;
  }
}
`
export const popUpSlideDownAnim = keyframes`
  0% {
    animation-timing-function: cubic-bezier(0.42, 0, 0.07, 0.93);
    transform: translateX(50%) translateY(-120px);
    opacity: 0;
  }
  50% {
    animation-timing-function: cubic-bezier(0.29, 0.14, 0.62, 1);
    transform: translateX(50%) translateY(20px);
    opacity: 1;
  }
  100% {
    transform: translateX(50%) translateY(0);
    opacity: 1;
  }
}
`
export const iconRotateAnim = keyframes`
    0% {
    transform: rotate(-45deg);
    animation-timing-function: cubic-bezier(0.23, 0.07, 0.08, 0.91);
    }
    33% {
    transform: rotate(13.34deg);
    animation-timing-function: cubic-bezier(0.28, -0.06, 0.61, 0.89);
    }
    66% {
    transform: rotate(-10.65deg);
    animation-timing-function: cubic-bezier(0.32, -0.18, 0.66, 1);
    }
    100% {
    transform: rotate(0deg);
    }
`
export const fadeInAnim = keyframes`
    0% {
      opacity: 0;
      animation-timing-function: cubic-bezier(0.33, 0, 0, 1);
    }
    100% {
      opacity:1;
    }

`
export const modalFadeOutAnim = keyframes`
   0% {
    animation-timing-function: cubic-bezier(0.42, 0, 0.07, 0.93);
    transform: translateY(0px);
    opacity: 1;
  }
  33% {
    animation-timing-function: cubic-bezier(0.29, 0.14, 0.62, 1);
    transform: translateY(-20px);
    opacity: 1;
  }
  100% {
    transform: translateY(200px);
    opacity: 0;
  }
`
